import API from './api';

export default class Manager extends API { }
